import React from 'react';

import ListSelectDisplay from './ListSelectDisplay';
import ListSelectEditor from './ListSelectEditor';
import ListSelectDesigner from './ListSelectDesigner';

const ListMultiSelect = {
  // pass additional 'multi' prop
  designer: (props) => <ListSelectDesigner {...props} multi />,
  display: (props) => <ListSelectDisplay {...props} multi />,
  editor: (props) => <ListSelectEditor {...props} multi />,
};

export default ListMultiSelect;



// WEBPACK FOOTER //
// ./src/components/types/ListSelect/ListMultiSelect.js